import { adminFetch } from "./_client";


export function fetchMarkupMultipliers(token: string) {
  return adminFetch<{ multipliers: Record<string, number>; configId: number | null }>("/admin/insurance/markup-multipliers", token);
}


export function updateMarkupMultipliers(token: string, multipliers: Record<string, number>) {
  return adminFetch<{ success: boolean }>("/admin/insurance/markup-multipliers", token, { method: "PUT", body: JSON.stringify({ multipliers }) });
}


export function fetchStateMultipliers(token: string) {
  return adminFetch<{ multipliers: Record<string, number>; configId: number | null }>("/admin/insurance/state-multipliers", token);
}


export function updateStateMultipliers(token: string, multipliers: Record<string, number>) {
  return adminFetch<{ success: boolean }>("/admin/insurance/state-multipliers", token, { method: "PUT", body: JSON.stringify({ multipliers }) });
}


export function applyAnnualPriceIncrease(token: string, percentage: number) {
  return adminFetch<{ success: boolean; rowsAffected: number; percentage: number }>("/admin/insurance/annual-price-increase", token, { method: "POST", body: JSON.stringify({ percentage }) });
}


export function fetchPriceIncreaseHistory(token: string) {
  return adminFetch<{ history: Array<{ date: string; percentage: number; multiplier: number; applied_by: string; rows_affected: number }> }>("/admin/insurance/price-increase-history", token);
}


export function fetchFloorAmount(token: string) {
  return adminFetch<{ floorAmount: number; configId: number | null }>("/admin/insurance/floor-amount", token);
}


export function updateFloorAmount(token: string, floorAmount: number) {
  return adminFetch<{ success: boolean }>("/admin/insurance/floor-amount", token, { method: "PUT", body: JSON.stringify({ floorAmount }) });
}


export function triggerMigrate1kRanges(token: string) {
  return adminFetch<{ success: boolean; rangesInserted: number; pricingInserted: number }>("/admin/insurance/migrate-1k-ranges", token, { method: "POST" });
}


export function fetchMigrationStatus(token: string) {
  return adminFetch<{ migrated: boolean }>("/admin/insurance/migration-status", token);
}
